import type { IInvoiceLineDto } from "@lib/ShiOneClient";
import { resolveProductQuickViewTarget } from "@features/orders-features/functions/productQuickView";

export function invoiceLineQuickView(line: IInvoiceLineDto) {
  const target = resolveProductQuickViewTarget({
    productClass: line.productClass,
    productDescriptor: line.productDescriptor,
    shiPartNumber: line.erpPartNumber,
  });
  if (!target) return null;

  const quantity = line.qtyInvoiced ?? line.qtyOrdered;
  const price =
    line.unitPrice ??
    (line.extendedPrice && quantity
      ? line.extendedPrice / quantity
      : line.extendedPrice);

  return {
    ...target,
    productName: line.description,
    mfrPartNum: line.mfgPartNumber,
    price,
  };
}
